import { pcbLayoutNestedNodeDelimiter, PcbNodeTypes, splitMultipartUID, } from "@buildwithflux/models";
import { mapValues } from "lodash";
import { getNodesOfType } from "../../nodes";
export function normalizeSubmoduleData(submoduleData) {
    // TODO very similar to Simulator.stripExtendedData. Will disappear when we move to snapshots.
    return {
        routeVertices: submoduleData.vertices,
        elements: mapValues(submoduleData.elements, (extendedElement) => extendedElement.element),
    };
}
/** For each Net node within a submodule, get the host net uid it's associated with.
 *
 * The reason for needing this is because of how we determine which host net a Trace
 * or Via node belongs to (eg to know whether to connect them to groundfill). Specifically,
 * we choose the Trace/Via's nearest parent/ancestor Net node.
 * However, for submodule Traces and Vias, that ancestor is not a host net. So we need to
 * determine the host net for each submodule Net node, which this map provides.
 */
export function mapSubmoduleNetsToHostNets(treeNodes, netNodesCache = new Map()) {
    const allNetNodes = getNodesOfType(treeNodes, PcbNodeTypes.net, netNodesCache);
    const submoduleTerminalsToNets = {};
    for (const netNode of allNetNodes) {
        for (const terminalUid of Object.keys(netNode.submoduleTerminals ?? {})) {
            submoduleTerminalsToNets[terminalUid] = netNode.uid;
        }
    }
    const __ = pcbLayoutNestedNodeDelimiter;
    const submoduleNetsToHostNets = {};
    for (const netNode of allNetNodes) {
        const fullElementUid = splitMultipartUID(netNode.uid)[0];
        const terminals = Object.keys(netNode.terminals ?? {});
        const matchingTerminal = terminals.find((t) => `${fullElementUid}${__}${t}` in submoduleTerminalsToNets);
        if (matchingTerminal) {
            submoduleNetsToHostNets[netNode.uid] =
                submoduleTerminalsToNets[`${fullElementUid}${__}${matchingTerminal}`];
        }
    }
    return submoduleNetsToHostNets;
}
//# sourceMappingURL=submodules.js.map